import { Component} from '@angular/core';
import { IonicPage, NavController, NavParams, ModalController, AlertController, ViewController, App } from 'ionic-angular';
import { HttpService } from '../../services/HttpService';

import { LoginPage } from '../login/login';

/**
 * Generated class for the BonusdetailPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-bonusdetail',
  templateUrl: 'bonusdetail.html',
})
export class BonusdetailPage {

    loginId: string;
	email: string;
    api_key: string;
    version: string;

    tab: string;
    date: string;

	coin_unit: string;
	unit: string;
	cash_room_unit: string;
	bonus_room_unit: string;

    list: any = [];

	texts: any = [];
    language : string;

    constructor(
		public navCtrl: NavController,
		public navParams: NavParams,
		private http: HttpService,
		public modalCtrl: ModalController,
		public alertCtrl:AlertController,
        public viewCtrl: ViewController,
		public app: App
    ) {
        this.tab = this.navParams.get('tab');
        this.date = this.navParams.get('date');
	}

    ionViewWillEnter() {
		//// 로그인이 안되어 있다면 로그인 화면으로 이동한다.
		this.api_key = localStorage.getItem("api_key");
		if(!this.api_key) {
			this.app.getRootNav().setRoot(LoginPage);
		}

		//// 페이지 이름
		localStorage.setItem("pageName", "bonusdetail");
		this.loginId = localStorage.getItem("loginId");
		this.email = localStorage.getItem("email");
		this.language = localStorage.getItem("language");
        this.version = localStorage.getItem("version");
		this.coin_unit = localStorage.getItem("coin_unit");
		this.unit = localStorage.getItem("unit");
		this.cash_room_unit = localStorage.getItem("cash_room_unit");
		this.bonus_room_unit = localStorage.getItem("bonus_room_unit");

        this._get_texts();

		this._init();
	}

    _get_texts() {
		this.texts = JSON.parse(localStorage.getItem('lang_pack')).bonusdetail;
	}

	_init() {
        let url = "bonus/base/index/detail";
		let body = JSON.stringify({ 
			api: this.api_key,
            language: this.language,
            version: this.version,
            tab: this.tab,
            date: this.date
		});
		this.http.post(url, body).then((res: any) => {
			if(res.result=="OK"){

                if (res.list != undefined) {
                    this.list = res.list;
                }
				
				// if(res.list != undefined) {
				// 	this.list = res.list;
				// 	this.max_length = res.list.length;
				// 	this.params = [];
				// 	this.count = 0;
				// 	for (var i = 0; i < 9; i++) {
				// 		if(this.max_length <= this.count) break;
				// 		this.params.push(this.items[this.count]);
				// 		this.count++;
				// 	}
				// }
			} else if(res.result ==="DONOT"){
                let alert = this.alertCtrl.create({
					message: res.message,
					buttons: ['OK']
				});
				alert.present();
                // this.navCtrl.pop();

			} else if(res.result ==="LOGOUT"){
				let alert = this.alertCtrl.create({
					message: res.message,
					buttons: ['OK']
				});
				alert.present();
				localStorage.removeItem("loginId");
				localStorage.removeItem("api_key");
				this.app.getRootNav().setRoot(LoginPage);
			
			} else {
				this.navCtrl.pop();
				let alert = this.alertCtrl.create({
					message: res.message,
					buttons: ['OK']
				});
				alert.present();
			}
		},(err)=>{
			let alert = this.alertCtrl.create({
				message: this.texts.alertM_err,
				buttons: ['OK']
			});
			alert.present();
		});
	}

    _close() {
        this.viewCtrl.dismiss(this.tab);
    }
}



// WEBPACK FOOTER //
// ./src/pages/bonusdetail/bonusdetail.ts